import React, { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import OutsideClick from '../../../components/OutsideClick/OutsideClick';
import { Col, Grid, Row } from '../../../grid';
import { block } from '../../../utils';
import { getNavigationItemWithIconSize } from '../../utils';
import DesktopNavigation from '../DesktopNavigation/DesktopNavigation';
import MobileNavigation from '../MobileNavigation/MobileNavigation';
import './Navigation.css';
const b = block('navigation');
export const Navigation = ({ data, logo, className }) => {
    const { leftItems, rightItems, iconSize = 20, withBorder = false, withBorderOnScroll = true, } = data;
    const [isSidebarOpened, setIsSidebarOpened] = useState(false);
    const [activeItemId, setActiveItemId] = useState(undefined);
    const [showBorder, setShowBorder] = useState(withBorder);
    const getNavigationItem = getNavigationItemWithIconSize(iconSize);
    const leftItemsWithIconSize = useMemo(() => leftItems.map(getNavigationItem), [getNavigationItem, leftItems]);
    const rightItemsWithIconSize = useMemo(() => rightItems === null || rightItems === void 0 ? void 0 : rightItems.map(getNavigationItem), [getNavigationItem, rightItems]);
    const onActiveItemChange = (id) => {
        setActiveItemId(id);
    };
    const onSidebarOpenedChange = (isOpen) => setIsSidebarOpened(isOpen);
    useEffect(() => {
        if (!withBorderOnScroll)
            return () => { };
        const showBorderOnScroll = () => {
            if (!showBorder) {
                setShowBorder(window.scrollY > 0);
            }
        };
        const scrollHandler = debounce(showBorderOnScroll, 20);
        window.addEventListener('scroll', scrollHandler, { passive: true });
        return () => window.removeEventListener('scroll', scrollHandler);
    });
    return (React.createElement(Grid, { className: b({ 'with-border': showBorder }, className) },
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement("nav", null,
                    React.createElement(DesktopNavigation, { logo: logo, activeItemId: activeItemId, onActiveItemChange: onActiveItemChange, leftItemsWithIconSize: leftItemsWithIconSize, rightItemsWithIconSize: rightItemsWithIconSize, isSidebarOpened: isSidebarOpened, onSidebarOpenedChange: onSidebarOpenedChange }),
                    React.createElement(OutsideClick, { onOutsideClick: () => onSidebarOpenedChange(false) },
                        React.createElement(MobileNavigation, { topItems: leftItemsWithIconSize, bottomItems: rightItemsWithIconSize, isOpened: isSidebarOpened, activeItemId: activeItemId, onActiveItemChange: onActiveItemChange })))))));
};
export default Navigation;
